import React from 'react';

const InterviewPracticeSection = () => {
  return (
    <section id="mock-interview" className="w-full font-sans px-4 md:px-8 bg-white py-16">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center relative">
        {/* Mobile: Image first, Desktop: Image first */}
        <div className="w-full md:w-1/2 relative order-1 md:order-1 mb-12 md:mb-0 flex items-center justify-center">
          <img 
            src="/Prepare with Guided Clinical Interview Chats.webp" 
            alt="AI-Powered Interview Practice chat interface" 
            className='w-full max-w-lg h-auto object-cover rounded-2xl' 
          />
        </div>
        
        {/* Mobile: Content second, Desktop: Content second */}
        <div className="w-full md:w-1/2 pl-0 md:pl-12 order-2 md:order-2">
          <p className="text-sm text-gray-600 mb-2 mt-4">AI-Powered Interview Practice</p>
          <h2 className="text-[24px] md:text-4xl md:font-sans mb-4 md:mb-12">
            Prepare with Guided<br />Clinical Interview Chats
          </h2>
          <p className='text-[16px] md:text-base mb-6 md:mb-12'>
            Sharpen your interview skills with our AI-powered chat simulator. Generate up to <strong>40 practice interview questions</strong> from clinical and general scenarios, and receive <strong>tailored feedback</strong> to help you improve your responses.
          </p>
          <button 
            className='bg-black text-white py-2 px-4 rounded-3xl hover:bg-gray-800 transition-colors'
            onClick={() => {
              window.location.href = '/signup?redirect=mock-interview';
            }}
          >
            Start Practising Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default InterviewPracticeSection;

